if (!customElements.get('get-app-qr-popup')) {
  customElements.define(
    'get-app-qr-popup',
    class GetAppQrPopup extends HTMLElement {
      constructor() {
        super();
        this.popupOverlay = this.querySelector('.get-app-popup__overlay');
        this.popupPanel = this.querySelector('.get-app-popup__panel');
        this.closeBtn = this.querySelector('.get-app-popup__close');
        this.onOpenRequested = this.open.bind(this);
        this.controller = null;
      }

      connectedCallback() {
        const init = () => {
          this.controller = window.createBacksheetController({
            host: this,
            overlay: this.popupOverlay,
            panel: this.popupPanel,
            closeBtn: this.closeBtn,
          });
          this.controller.bind();
          document.addEventListener('vwo:open-get-app-popup', this.onOpenRequested);
        };

        document.readyState === 'loading'
          ? document.addEventListener('DOMContentLoaded', init, { once: true })
          : init();
      }

      open() {
        this.controller?.open();
      }

      disconnectedCallback() {
        this.controller?.unbind();
        document.removeEventListener('vwo:open-get-app-popup', this.onOpenRequested);
      }
    },
  );
}
